module.exports = __webpack_public_path__ + "c6085adc03c86845caafc086e4d49190.svg";